import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  GraduationCap, 
  Heart, 
  Globe, 
  Users, 
  Phone, 
  ExternalLink,
  MessageCircle,
  Smartphone,
  BookOpen,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

const SocialWelfareActivitiesPage = () => {
  const [expandedCard, setExpandedCard] = useState('scholarship');

  const toggleCard = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  const activities = [
    {
      id: 'scholarship',
      icon: GraduationCap,
      title: 'अखिल भारतीय मारवाड़ी ब्रह्मक्षत्रिय सामाजिक छात्रवृत्ति समूह',
      titleEn: 'All India Marwadi Brahmkshatriya Social Scholarship Group',
      highlight: '5 वर्षों में ₹5 लाख छात्रवृत्ति वितरित',
      description: 'विभिन्न स्थानों के समाज के जिम्मेदार पांच व्यक्तियों का समूह रु 300 प्रतिमाह सहयोग राशि एकत्र कर समाज के होनहार जरुरतमंद छात्रों में वितरित करता है। पारदर्शी व सुव्यवस्थित प्रणाली से कार्यरत यह समूह शिक्षा प्रसार में महत्वपूर्ण योगदान दे रहा है। पांच वर्षों में रु पांच लाख की छात्रवृत्ति वितरित की जा चुकी है।',
      contacts: ['87789 43353', '94824 31911', '94166 24051', '98251 56537', '87640 26256'],
      contactNote: 'छात्रवृत्ति प्राप्त करने या छात्रवृत्ति फंड में राशि जमा कराने हेतु इन नम्बरों पर सम्पर्क किया जा सकता है',
      color: 'orange'
    },
    {
      id: 'jeevansathi',
      icon: Heart,
      title: 'ब्रह्मक्षत्रिय जीवनसाथी ग्रुप व एप',
      titleEn: 'Brahmkshatriya Jeevansathi Group & App',
      highlight: '4000+ सदस्य | 800+ बायोडाटा | 90+ रिश्ते',
      description: 'आपदा में अवसर ढूंढना सृजनशील व्यक्तियों का स्वभाव होता है। लॉकडाऊन में घर बैठे समाज के दो व्यक्तियों ने 15 जून, 2020 को वॉट्स एप पर ग्रुप बनाकर विवाह योग्य युवक युवतियों के विवरण पोस्ट करना शुरु किया। बाद में तीसरे व्यक्ति को ग्रुप एडमिन बनाया गया, जो ज्यादा सक्रिय सिद्ध हुयी। धीरे धीरे दस ग्रुप्स बन गये। इन ग्रुप्स में 4000+ व्यक्ति जुड़े हैं। 800+ बायोडाटा पोस्ट हुये हैं व 90 रिश्ते हुये हैं।',
      additionalInfo: '2021 में उन्होंने समाज के ही एक आई टी विशेषज्ञ से ब्रह्मक्षत्रिय जीवनसाथी एप बनवाया गया। एप में 1100+ प्रॉफाइल्स बन चुकी हैं।',
      appLink: 'https://play.google.com/store/apps/details?id=com.brahmkshatriyajeevansathi',
      appLinkText: 'Download App from Play Store',
      contacts: ['99621 12572', '87640 26256', '99677 55489', '77379 82977'],
      tagline: 'सर्विस थ्रू टेक्नोलॉजी का यह श्रेष्ठ उदाहरण है।',
      color: 'pink'
    },
    {
      id: 'websites',
      icon: Globe,
      title: 'वेबसाइट्स, फेसबुक ग्रुप्स व वॉट्स एप ग्रुप्स',
      titleEn: 'Websites, Facebook Groups & WhatsApp Groups',
      highlight: '11,000+ सदस्य | 15+ वर्ष पुराना',
      sections: [
        {
          title: 'पहली वेबसाइट (सन् 2000)',
          description: 'हमारे समाज की पहली वेबसाइट सन् 2000 में ही बना दी गयी थी। उसमें समाजोपयोगी जानकारी, मेट्रीमोनियल सर्विस, समाज की डायरेक्टरी आदि फिचर्स थे। उसका एक फेसबुक ग्रुप International Brahmkshatriya Group for www.brahmkshatriya.net.in अभी सक्रिय है, जिसके ग्यारह हजार से ज्यादा सदस्य हैं। 15 वर्ष पुराने इस ग्रुप में समाज के समाचार आदि पोस्ट किये जाते हैं।',
          link: 'https://www.facebook.com/groups/118091144876975',
          linkText: 'Facebook Group देखें',
          contacts: ['93567 89386', '94133 29265']
        },
        {
          title: 'hinglajjayate.com',
          description: 'यह वेबसाइट भी व्यक्तिगत स्तर पर बनाई गयी है, जिसमें समाजोपयोगी जानकारी व फोन डायरेक्टरी का समावेश है। इन्होनें समाज के परिवारों की डायरेक्टरीज प्रकाशित भी की थी।',
          link: 'http://hinglajjayate.com',
          linkText: 'hinglajjayate.com',
          contacts: ['94142 69286']
        }
      ],
      color: 'blue'
    },
    {
      id: 'whatsapp',
      icon: MessageCircle,
      title: 'वॉट्सएप ग्रुप्स',
      titleEn: 'WhatsApp Groups',
      highlight: 'समाचारों व जानकारी की त्वरित डिलीवरी',
      description: 'समाज बंधुओं को सदस्य बनाते हुये अनेक वॉट्सएप ग्रुप्स सक्रिय हैं। इन ग्रुप्स की उपयोगिता सिद्ध है। समाचारों व जानकारी को तुरंत डिलीवर करने और सामाजिक चर्चा कराने में इन ग्रूप्स का महत्वपूर्ण योगदान है।',
      contacts: ['79769 55946', '94824 31911'],
      contactNote: 'अति सक्रिय विवरण प्रेषकों व चर्चा आयोजकों के सम्पर्क नम्बर',
      color: 'green'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      orange: {
        bg: 'bg-orange-50',
        border: 'border-orange-200',
        icon: 'bg-orange-100 text-orange-600',
        badge: 'bg-orange-100 text-orange-700',
        header: 'from-orange-500 to-primary'
      },
      pink: {
        bg: 'bg-pink-50',
        border: 'border-pink-200',
        icon: 'bg-pink-100 text-pink-600',
        badge: 'bg-pink-100 text-pink-700',
        header: 'from-pink-500 to-rose-500'
      },
      blue: {
        bg: 'bg-blue-50',
        border: 'border-blue-200',
        icon: 'bg-blue-100 text-blue-600',
        badge: 'bg-blue-100 text-blue-700',
        header: 'from-blue-500 to-indigo-500'
      },
      green: {
        bg: 'bg-green-50',
        border: 'border-green-200',
        icon: 'bg-green-100 text-green-600',
        badge: 'bg-green-100 text-green-700',
        header: 'from-green-500 to-teal-500'
      }
    };
    return colors[color] || colors.orange;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="gradient-orange py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-white/80 text-sm mb-6">
            <a href="/" className="hover:text-white">Home</a>
            <span>›</span>
            <a href="#" className="hover:text-white">About Samaj</a>
            <span>›</span>
            <span>Social Welfare Activities</span>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Social Welfare Activities
            </h1>
            <p className="text-2xl text-white/95 font-medium mb-2">
              सामाजिक कल्याण गतिविधियां
            </p>
            <p className="text-lg text-white/90 leading-relaxed">
              समाज सेवा के विभिन्न आयाम - छात्रवृत्ति, वैवाहिक सहायता, डिजिटल पहल
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Introduction */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-primary/5 to-orange-50 rounded-2xl p-8 border border-primary/10 mb-12"
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
            <Users className="w-8 h-8 text-primary" />
            समाज सेवा की पहल
          </h2>
          <p className="text-gray-700 leading-relaxed">
            हमारे समाज के सेवाभावी बंधुओं ने व्यक्तिगत व सामूहिक स्तर पर अनेक सामाजिक कल्याण गतिविधियां प्रारम्भ की हैं। 
            शिक्षा के प्रसार के लिये छात्रवृत्ति योजना, विवाह योग्य युवक-युवतियों के लिये जीवनसाथी खोज सेवा, 
            तथा आधुनिक तकनीक का उपयोग करते हुये वेबसाइट्स व सोशल मीडिया ग्रुप्स के माध्यम से समाज को जोड़ने का कार्य किया जा रहा है।
          </p>
        </motion.div>

        {/* Activity Cards */}
        <div className="space-y-6">
          {activities.map((activity, index) => {
            const colorClasses = getColorClasses(activity.color);
            const IconComponent = activity.icon;
            
            return (
              <motion.div
                key={activity.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
              >
                {/* Card Header */}
                <button
                  onClick={() => toggleCard(activity.id)}
                  className={`w-full px-6 py-5 flex items-center justify-between ${colorClasses.bg} hover:opacity-90 transition-opacity`}
                >
                  <div className="flex items-center gap-4">
                    <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${colorClasses.icon}`}>
                      <IconComponent className="w-7 h-7" />
                    </div>
                    <div className="text-left">
                      <h3 className="text-xl font-bold text-gray-900">{activity.title}</h3>
                      <p className="text-sm text-gray-500">{activity.titleEn}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    {activity.highlight && (
                      <span className={`hidden md:inline-block px-3 py-1 ${colorClasses.badge} text-sm font-medium rounded-full`}>
                        {activity.highlight}
                      </span>
                    )}
                    {expandedCard === activity.id ? (
                      <ChevronUp className="w-6 h-6 text-gray-400" />
                    ) : (
                      <ChevronDown className="w-6 h-6 text-gray-400" />
                    )}
                  </div>
                </button>

                {/* Card Content */}
                {expandedCard === activity.id && (
                  <div className="px-6 pb-6 border-t border-gray-100">
                    {/* Mobile highlight badge */}
                    {activity.highlight && (
                      <div className="md:hidden py-4">
                        <span className={`inline-block px-3 py-1 ${colorClasses.badge} text-sm font-medium rounded-full`}>
                          {activity.highlight}
                        </span>
                      </div>
                    )}

                    {/* Description */}
                    {activity.description && (
                      <p className="text-gray-700 leading-relaxed py-4">
                        {activity.description}
                      </p>
                    )}

                    {/* Additional Info */}
                    {activity.additionalInfo && (
                      <p className="text-gray-700 leading-relaxed mb-4">
                        {activity.additionalInfo}
                      </p>
                    )}

                    {/* Tagline */}
                    {activity.tagline && (
                      <p className="italic text-gray-600 border-l-4 border-primary/30 pl-4 mb-4">
                        {activity.tagline}
                      </p>
                    )}

                    {/* App Link */}
                    {activity.appLink && (
                      <div className="mb-6">
                        <a
                          href={activity.appLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-600 text-white px-5 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all shadow-md"
                        >
                          <Smartphone className="w-5 h-5" />
                          {activity.appLinkText}
                          <ExternalLink className="w-4 h-4" />
                        </a>
                      </div>
                    )}

                    {/* Sections (for websites) */}
                    {activity.sections && (
                      <div className="space-y-6 py-4">
                        {activity.sections.map((section, idx) => (
                          <div key={idx} className={`${colorClasses.bg} rounded-xl p-5 border ${colorClasses.border}`}>
                            <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                              <Globe className="w-5 h-5 text-blue-600" />
                              {section.title}
                            </h4>
                            <p className="text-gray-700 leading-relaxed mb-4">
                              {section.description}
                            </p>
                            {section.link && (
                              <a
                                href={section.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium"
                              >
                                <ExternalLink className="w-4 h-4" />
                                {section.linkText}
                              </a>
                            )}
                            {section.contacts && (
                              <div className="mt-4 pt-4 border-t border-gray-200">
                                <p className="text-sm text-gray-500 mb-2 flex items-center gap-2">
                                  <Phone className="w-4 h-4" />
                                  सम्पर्क नम्बर:
                                </p>
                                <div className="flex flex-wrap gap-2">
                                  {section.contacts.map((contact, cIdx) => (
                                    <a
                                      key={cIdx}
                                      href={`tel:${contact.replace(/\s/g, '')}`}
                                      className="px-3 py-1 bg-white rounded-full text-sm font-medium text-gray-700 hover:bg-gray-100 border border-gray-200 transition-colors"
                                    >
                                      {contact}
                                    </a>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Contact Numbers */}
                    {activity.contacts && !activity.sections && (
                      <div className={`${colorClasses.bg} rounded-xl p-5 border ${colorClasses.border} mt-4`}>
                        <p className="text-sm text-gray-600 mb-3 flex items-center gap-2">
                          <Phone className="w-4 h-4" />
                          {activity.contactNote || 'सम्पर्क नम्बर:'}
                        </p>
                        <div className="flex flex-wrap gap-2">
                          {activity.contacts.map((contact, idx) => (
                            <a
                              key={idx}
                              href={`tel:${contact.replace(/\s/g, '')}`}
                              className="px-4 py-2 bg-white rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 border border-gray-200 transition-colors flex items-center gap-2"
                            >
                              <Phone className="w-4 h-4 text-primary" />
                              {contact}
                            </a>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 bg-gradient-to-br from-orange-500 to-primary rounded-2xl p-8 text-white text-center"
        >
          <h2 className="text-2xl font-bold mb-4">
            🙏 समाज सेवा में योगदान दें
          </h2>
          <p className="text-white/90 leading-relaxed max-w-2xl mx-auto">
            इन सभी सेवाओं में योगदान देने वाले समाज बंधुओं को हमारा नमन। 
            आप भी इन गतिविधियों से जुड़कर समाज की सेवा में अपना योगदान दे सकते हैं।
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default SocialWelfareActivitiesPage;
